import { render, staticRenderFns } from "./SendMessageTargetFamilyRow.vue?vue&type=template&id=0123c7d2&scoped=true&lang=pug"
import script from "./SendMessageTargetFamilyRow.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetFamilyRow.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetFamilyRow.vue?vue&type=style&index=0&id=0123c7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123c7d2",
  null
  
)

export default component.exports